import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class WorkOrders_ds_get_accessorial_template_operationcodes_by_projectIdService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { projectId: number }): 
  Promise<{ result: { BillingContractLineId?: number, StrategyFieldName?: string, Value?: string, BillingContractLine?: { ResultingUomId?: number }, operation_codes?: { Id?: number, BillingAccessorialChargeTemplateId?: number, OperationCodeId?: number, OperationCode?: { Name?: string } }[] }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.projectId)) {
      $missingRequiredInParams.push('\'projectId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { projectId: number, $top?: number, $skip?: number }): 
  Promise<{ result: { BillingContractLineId?: number, StrategyFieldName?: string, Value?: string, BillingContractLine?: { ResultingUomId?: number }, operation_codes?: { Id?: number, BillingAccessorialChargeTemplateId?: number, OperationCodeId?: number, OperationCode?: { Name?: string } }[] }[], totalCount: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.projectId)) {
      $missingRequiredInParams.push('\'projectId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { projectId: number, $keys: { BillingContractLineId?: number, StrategyFieldName?: string }[] }): 
  Promise<{ result: { BillingContractLineId?: number, StrategyFieldName?: string, Value?: string, BillingContractLine?: { ResultingUomId?: number }, operation_codes?: { Id?: number, BillingAccessorialChargeTemplateId?: number, OperationCodeId?: number, OperationCode?: { Name?: string } }[] }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.projectId)) {
      $missingRequiredInParams.push('\'projectId\'');
    }
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      projectId: number    }) {
        if(isNil($inParams.projectId)) {
          return true; 
        }
      return false;
    }
}
